import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Path 3811" d="M12 0A12 12 0 110 12 12 12 0 0112 0z" fill="#6c7778" /></svg>);